// Re-export types from the service for convenience
export type {
  SystemConfiguration,
  DefaultFiltersConfig,
  SubtramitesConfig,
  FileSettingsConfig,
  SessionSettingsConfig,
  NotificationSettingsConfig,
  InterfaceSettingsConfig,
  WhatsAppSettingsConfig,
  ContabilidadSettingsConfig
} from '@/services/systemConfigurationService';

// Additional types specific to the UI components
export interface ConfigurationTabProps {
  title: string;
  icon: React.ComponentType<any>;
  isActive: boolean;
  onClick: () => void;
}

export interface ConfigurationFormProps {
  loading?: boolean;
  onSave?: () => void;
  hasChanges?: boolean;
}

// Available subtramites for configuration
export const AVAILABLE_SUBTRAMITES = [
  { key: 'catastral', name: 'Catastral', description: 'Certificado catastral' },
  { key: 'reserva', name: 'Reserva', description: 'Reserva de nomenclatura' },
  { key: 'atm', name: 'ATM', description: 'Aprobación técnica municipal' },
  { key: 'planomensura', name: 'Plano Mensura', description: 'Plano de mensura' },
  { key: 'planorelevamiento', name: 'Plano Relevamiento', description: 'Plano de relevamiento' },
  { key: 'municipalidad', name: 'Municipalidad', description: 'Trámites municipales' },
  { key: 'vialidad', name: 'Vialidad', description: 'Dirección de vialidad' },
  { key: 'aguas', name: 'Aguas', description: 'Obras sanitarias' },
  { key: 'expensas', name: 'Expensas', description: 'Certificado de expensas' },
  { key: 'irrigacion', name: 'Irrigación', description: 'Departamento de irrigación' },
  { key: 'presupuestos', name: 'Presupuestos', description: 'Presupuestos y cotizaciones' },
  { key: 'estudiotitulo', name: 'Estudio Título', description: 'Estudio de título' },
] as const;

export type SubtramiteKey = typeof AVAILABLE_SUBTRAMITES[number]['key'];

// Configuration categories for tabs
export const CONFIGURATION_CATEGORIES = [
  { key: 'subtramites', name: 'Subtramites', description: 'Configuración de subtramites por defecto' },
  { key: 'whatsapp', name: 'WhatsApp', description: 'Parámetros de envíos, idempotencia y enlaces temporales' },
  { key: 'contabilidad', name: 'Contabilidad', description: 'Fecha de corte de pendientes y fondo de certificaciones y poderes' },
  { key: 'presupuestos', name: 'Presupuestos', description: 'Destinos de pago de los presupuestos' },
] as const;

export type ConfigurationCategory = typeof CONFIGURATION_CATEGORIES[number]['key'];
